import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { DefaultLayout } from './layouts/DefaultLayout';
import { Home } from './pages/Home';
import { Review } from './pages/Review';
import { Search } from './pages/Search';
import { Reservation } from './pages/Reservation';
import { Helmet } from 'react-helmet';
import { HotelContextProvider } from './modules/HotelContext';
import { VNPayReturnPage } from './pages/VNPayReturn';
import { VietQRPayment } from './pages/VietQRPayment';
import { PaymentReturnPage } from './pages/PaymentReturn';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

function App() {
  return (
    <>
      <Helmet titleTemplate="%s | Đào Tiên Hotel" />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <DefaultLayout>
                  <Home />
                </DefaultLayout>
              }
            />
            <Route path="/embed" element={<Home />} />
            <Route
              path="/search/:hotelId"
              element={
                <DefaultLayout>
                  <HotelContextProvider>
                    <Search />
                  </HotelContextProvider>
                </DefaultLayout>
              }
            />
            <Route
              path="/search/:hotelId/room/:roomTypeId"
              element={
                <DefaultLayout>
                  <HotelContextProvider source="search">
                    <Review />
                  </HotelContextProvider>
                </DefaultLayout>
              }
            />
            <Route
              path="/:hotelId"
              element={
                <DefaultLayout>
                  <HotelContextProvider>
                    <Outlet />
                  </HotelContextProvider>
                </DefaultLayout>
              }>
              <Route path="reservation/:reservationId" element={<Reservation />} />
              <Route path="payment/vietqr" element={<VietQRPayment />} />
              <Route path="payment/return" element={<PaymentReturnPage />} />
            </Route>
            <Route
              path="/embed/:hotelId"
              element={
                <HotelContextProvider>
                  <Outlet />
                </HotelContextProvider>
              }>
              <Route path="" element={<Search />} />
              <Route path="room/:roomTypeId" element={<Review />} />
              <Route path="reservation/:reservationId" element={<Reservation />} />
              <Route path="payment/vietqr" element={<VietQRPayment />} />
              <Route path="payment/return" element={<PaymentReturnPage />} />
            </Route>
            <Route
              path="/vnpay_return"
              element={
                <DefaultLayout>
                  <VNPayReturnPage />
                </DefaultLayout>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </>
  );
}

export default App;
